import { Button, HStack, Text, VStack } from "@chakra-ui/react"
import { formatCurrency } from "@/utilities/number"
import { useAuth } from "contexts/auth"
import { useStore } from "contexts/store"
import GuestPriceNotice from "./GuestPriceNotice"

const SingleProductPrice = ({ price, originalPrice, unit = "₫" }) => {
    const { user, showLogin } = useAuth()
    const { store } = useStore()
    const canShowPrice = !!user || !!store?.web?.public_price_display

    if (!canShowPrice) {

        return (
            <VStack>
                <GuestPriceNotice />
                <Button onClick={showLogin}>
                  Đăng nhập
                </Button>
            </VStack>
        )



    }

    const displayPrice = price ?? originalPrice

    return (
        <Text fontWeight="semibold">
            Giá:  {formatCurrency(displayPrice)} {unit}
        </Text>
    )
}

export default SingleProductPrice